import { motion } from "framer-motion";

const reasons = [
  { title: "Premium Design", desc: "Every pixel is intentional — refined layouts that feel luxurious and timeless." },
  { title: "Fast Delivery", desc: "AI-powered workflows mean your site launches in days, not months." },
  { title: "Mobile Friendly", desc: "Beautiful and functional across phones, tablets and desktops alike." },
  { title: "SEO Optimized", desc: "Built to be discovered — clean code and structure that search engines love." },
  { title: "Affordable Pricing", desc: "Agency-grade quality without the agency-grade price tag." },
];

export default function WhyChooseMe() {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="relative py-28 md:py-40 border-t border-white/5"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-[0.8fr_1.2fr] gap-14 lg:gap-24">
          <div className="lg:sticky lg:top-32 self-start">
            <div className="flex items-center gap-4 mb-6">
              <span className="h-px w-12 bg-[#d4af37]" />
              <span className="text-xs uppercase tracking-[0.3em] gold-text">Why Choose Me</span>
            </div>
            <h2 className="font-serif-display font-light text-4xl md:text-6xl tracking-tight leading-[1.05]">
              A partner, not just a <span className="italic gold-text">provider.</span>
            </h2>
            <p className="mt-6 text-white/50 leading-relaxed max-w-md">
              You get a designer who cares about your growth as much as the aesthetics —
              committed to a result that actually performs.
            </p>
          </div>

          <div>
            {reasons.map((r, i) => (
              <motion.div
                key={r.title}
                data-testid={`why-item-${i}`}
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: i * 0.05 }}
                className="group flex items-center gap-6 md:gap-10 py-8 border-b border-white/10"
              >
                <span className="font-serif-display text-2xl md:text-3xl text-[#d4af37] w-12 shrink-0">
                  0{i + 1}
                </span>
                <div className="flex-1">
                  <h3 className="font-serif-display text-2xl md:text-4xl mb-1 group-hover:translate-x-2 transition-transform duration-500">
                    {r.title}
                  </h3>
                  <p className="text-white/50 leading-relaxed">{r.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
